/* eslint-disable consistent-return */

import { useEffect, useRef, useState } from 'react';

export function useEventListener(
	eventName,
	handler,
	element = window,
	evaluate = true
) {
	const savedHandler = useRef();
	const [cleared, setCleared] = useState(false);

	useEffect(() => {
		savedHandler.current = handler;
	}, [handler]);

	useEffect(() => {
		if (cleared || !evaluate) {
			return;
		}

		const isSupported = element?.addEventListener;
		if (!isSupported) {
			return;
		}

		const eventListener = (event) => savedHandler.current(event);

		element.addEventListener(eventName, eventListener);

		return () => {
			element.removeEventListener(eventName, eventListener);
		};
	}, [eventName, element, evaluate, cleared]);

	return () => {
		setCleared(true);
	};
}
